import React from "react";
import { Quote, Clock, Euro } from "lucide-react";
import InfoModal from "../InfoModal";
import BookServiceButton from "./BookServiceButton";
import { coupleTherapy } from "../../data/servicesContent";

const CoupleSection = () => {
  return (
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      <div className="rounded-2xl overflow-hidden shadow-xl border-4 border-[#F5F3EB] order-2 lg:order-1">
        <img
          src={coupleTherapy.image.src}
          alt={coupleTherapy.image.alt}
          loading="lazy"
          className="w-full h-auto object-cover"
        />
      </div>

      <div className="order-1 lg:order-2 space-y-5">
        <h2 className="font-display text-3xl font-semibold text-[#21167D]">{coupleTherapy.heading}</h2>
        <p className="font-accent italic text-xl text-[#4A4458]">{coupleTherapy.subheading}</p>
        <p className="text-lg text-[#4A4458] leading-relaxed">{coupleTherapy.intro}</p>

        <p className="text-[#4A4458]">{coupleTherapy.roleIntro}</p>
        <ul className="list-disc list-inside space-y-2 text-[#4A4458]">
          {coupleTherapy.roleItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p className="text-[#4A4458] leading-relaxed">{coupleTherapy.goal}</p>

        <div className="flex flex-wrap gap-3">
          <InfoModal
            triggerLabel="En savoir plus"
            title={coupleTherapy.heading}
            subtitle={coupleTherapy.subheading}
          >
            {coupleTherapy.more.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            <blockquote className="flex gap-3 p-4 bg-[#21167D]/5 rounded-xl border-l-4 border-[#EAA93D]">
              <Quote className="w-5 h-5 text-[#DCB071] flex-shrink-0 mt-1" />
              <span className="font-accent italic text-[#21167D]">« {coupleTherapy.quote} »</span>
            </blockquote>

            <blockquote className="p-4 bg-[#21167D] text-[#F5F3EB] rounded-xl">
              <span className="font-accent italic text-lg">« {coupleTherapy.highlightedQuote} »</span>
            </blockquote>

            <div className="flex flex-wrap gap-4 pt-2">
              <div className="flex items-center gap-2 px-4 py-2 bg-[#F5F3EB] rounded-lg">
                <Clock className="w-4 h-4 text-[#21167D]" />
                <span className="text-sm font-medium text-[#4A4458]">{coupleTherapy.duration}</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-[#DCB071]/20 rounded-lg">
                <Euro className="w-4 h-4 text-[#21167D]" />
                <span className="text-sm font-bold text-[#21167D]">{coupleTherapy.price}</span>
              </div>
            </div>
          </InfoModal>
          <BookServiceButton serviceId="therapie-couple" />
        </div>
      </div>
    </div>
  );
};

export default CoupleSection;
